import { Container, Nav, Navbar } from 'react-bootstrap';
import logo from '../assets/logo.svg';

export const EarthGraphyNavbar = () => (
  <Navbar expand="sm" className="border-top border-4 border-primary py-0">
    <Container>
      <Navbar.Brand href="https://www.jaxa.jp/">
        <img src={logo} alt="JAXA logo" height="63" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="header-navbar" />
      <Navbar.Collapse id="header-navbar">
        <Nav>
          <Nav.Link href="http://www.satnavi.jaxa.jp/">第一宇宙技術部門</Nav.Link>
          <Nav.Link href="/">Earth-graphy</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);
